import styled from 'styled-components'

export const RadioMain = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 100%;
    width: 100%;
    background-color: 'rgba(0, 0, 255, 0)';
    border: 0px- 1px 1px 1px solid ${({ theme }) => theme['gray-200']};

    .radioButtonTitle {
        margin-bottom: 18px;
        line-height: 16px;
        color: ${({ theme }) => theme['gray-800']};
        font-family: ${({ theme }) => theme['font-semibold']};
        font-size: 13px;
        margin-bottom: 10px;
    }

    .radioButton {
        display: block;
        position: relative;
        cursor: pointer;
        font-size: 22px;
        user-select: none;
    }

    .radioButton input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        border: 1px solid #ffffff;
    }

    .radioButtonCheckmark {
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        position: absolute;
        top: 0;
        left: 0;
        height: 16px;
        width: 16px;
        background-color: white;
        border-radius: 50%;
        border: 1px solid #868695;
    }

    .radioButton:hover input .radioButtonCheckmark {
        background-color: #f5f5f5;
    }

    .radioButton input:checked .radioButtonCheckmark {
        background-color: white;
    }

    .radioButtonCheckmark:after {
        content: '';
        position: absolute;
        display: none;
    }

    .radioButton input:checked ~ .radioButtonCheckmark:after {
        display: block;
    }

    .radioButton .radioButtonCheckmark:after {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #37a3ef;
    }

    .activeLabel {
        margin-left: 24px;
        margin-right: 18px;
    }

    .inactiveLabel {
        margin-left: 24px;
    }
`

export const Title = styled.text`
    margin-bottom: 18px;
    margin-left: 6px;
    line-height: 16px;
    color: ${({ theme }) => theme['gray-800']};
    font-family: ${({ theme }) => theme['font-semibold']};
    font-size: 13px;
`
